<template>
  <div :class="{ 'forecast-zhiyun-version': versionConfig.ZHIYUN_VERSION }">
    <head-nav-bar title="房情预测" :fixed="true" left-arrow />
    <div class="mt-header-nav">
      <!-- <van-field disabled>
        <template slot="input"> -->
      <van-row type="flex" style="margin-top:10px" justify="space-around">
        <van-col span="18">
          <DateRangePicker
            :min="min"
            :value.sync="daterange"
            @change="onChangeDate"
          ></DateRangePicker>
        </van-col>
        <van-col span="4">
          <van-button type="info" size="small" @click="onSearch">
            查询
          </van-button>
        </van-col>
      </van-row>
      <!-- </template>
      </van-field> -->

      <div
        style="width:100%"
        v-for="(item, index) in roomData.DataSummary"
        :key="index"
        class="mainTable"
      >
        <div style="width:100%;display: inline-block;">
          <table style="width:100%">
            <tr>
              <td style="width:33%" class="roomDateCss">
                {{ item.Date }}
              </td>
              <td class="roomOtherDateCss">
                在住
              </td>
              <td class="roomOtherDateCss">
                预订
              </td>
              <td class="roomOtherDateCss">
                可卖
              </td>
              <td class="roomOtherDateCss">
                预离
              </td>
              <td class="roomOtherDateCss">
                维修
              </td>
            </tr>
            <tr v-for="(item2, index2) in roomData.Details" :key="index2">
              <td style="width:33%" class="roomTypeCss">
                {{ item2.RoomTypeName }}<br />
                {{ item2.Quantity }} 间
              </td>
              <td
                class="roomOtherTypeCss"
                @click="
                  onClick(
                    item2.PredictCalendars[index],
                    item2.RoomTypeName,
                    'CheckIn',
                  )
                "
              >
                {{ item2.PredictCalendars[index].CheckIn }}
              </td>
              <td
                class="roomOtherTypeCss"
                @click="
                  onClick(
                    item2.PredictCalendars[index],
                    item2.RoomTypeName,
                    'Booking',
                  )
                "
              >
                {{ item2.PredictCalendars[index].Booking }}
              </td>
              <td class="roomOtherTypeCss">
                {{ item2.PredictCalendars[index].Saleable }}
              </td>
              <td
                class="roomOtherTypeCss"
                @click="
                  onClick(
                    item2.PredictCalendars[index],
                    item2.RoomTypeName,
                    'Leaving',
                  )
                "
              >
                {{ item2.PredictCalendars[index].Leaving }}
              </td>
              <td class="roomOtherTypeCss">
                {{ item2.PredictCalendars[index].Repair }}
              </td>
            </tr>
            <tr>
              <td class="roomTotal">
                <!-- 总计({{
                  item.CheckIn +
                    item.Booking +
                    item.Saleable +
                    item.Leaving +
                    item.Repair
                }}) -->
                总计({{ item.Quantity }})
              </td>
              <td
                class="roomOtherTypeCss2"
                @click="onClick(item, '总计', 'CheckIn')"
              >
                {{ item.CheckIn }}
              </td>
              <td
                class="roomOtherTypeCss2"
                @click="onClick(item, '总计', 'Booking')"
              >
                {{ item.Booking }}
              </td>
              <td class="roomOtherTypeCss2">
                {{ item.Saleable }}
              </td>
              <td
                class="roomOtherTypeCss2"
                @click="onClick(item, '总计', 'Leaving')"
              >
                {{ item.Leaving }}
              </td>
              <td class="roomOtherTypeCss2">
                {{ item.Repair }}
              </td>
            </tr>
            <tr class="roomTotal">
              <td class="roomTotal">
                出租率
              </td>
              <td class="roomTotal" colspan="5">
                {{ item.RentRate }}
              </td>
            </tr>
            <tr class="roomTotal">
              <td class="roomTotal">
                平均房价
              </td>
              <td class="roomTotal" colspan="5">
                {{ item.AvgRoomPrice }}
              </td>
            </tr>
            <tr class="roomTotal">
              <td class="roomTotal">
                房费预测
              </td>
              <td class="roomTotal" colspan="5">
                {{ item.PredictRoomPrice }}
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <PredictRoomInfosPop ref="PredictRoomInfosPop"></PredictRoomInfosPop>
  </div>
</template>

<script>
import moment from "moment";
import DateRangePicker from "@/components/date-range-picker/DateRangePicker.vue";
import roomApi from "../../api/room.js";
import { mapState } from "vuex";
import { Row, Col, Button } from "vant";
import PredictRoomInfosPop from "./roomComponent/PredictRoomInfosPop";
export const PREDICTIROOMINFOTYPES = {
  Leaving: "3", //预离
  Booking: "2", //预入
  CheckIn: "1", //在住
};
export const PREDICTIROOMINFO = {
  Leaving: "预离", //预离
  Booking: "预订", //预入
  CheckIn: "在住", //在住
};
export default {
  components: {
    PredictRoomInfosPop,
    [Row.name]: Row,
    [Col.name]: Col,
    [Button.name]: Button,
    DateRangePicker,
  },
  data() {
    return {
      // eslint-disable-next-line no-undef
      versionConfig,
      min: "",
      max: "",
      daterange: [],
      roomData: [],
    };
  },
  created() {
    this.min = this.user.AccountDate;
    this.max = moment(this.user.AccountDate)
      .add(1, "d")
      .format("YYYY-MM-DD");
    this.daterange = [
      this.user.AccountDate,
      moment(this.user.AccountDate)
        .add(1, "d")
        .format("YYYY-MM-DD"),
    ];

    const params = {
      CompanyId: this.user.CompanyId,
      StartDate: this.user.AccountDate,
      EndDate: moment(this.user.AccountDate)
        .add(1, "d")
        .format("YYYY-MM-DD"),
    };
    this.getData(params);
  },
  computed: {
    ...mapState({
      user: state => state.user.info,
    }),
  },
  methods: {
    onClick(item, roomTypeName, code) {
      const title = `${roomTypeName}【${PREDICTIROOMINFO[code]}】`;
      this.$refs.PredictRoomInfosPop.onShow(
        item.PredictRoomInfosObj[PREDICTIROOMINFOTYPES[code]],
        title,
      );
    },
    onChangeDate(val) {
      if (val[0] && val[1] && moment(val[0]).isAfter(val[1])) {
        val[1] = moment(val[0])
          .add(1, "d")
          .format("YYYY-MM-DD");
      }
      this.daterange = val;
    },
    getData(params) {
      var _this = this;
      var myDate = new Date();
      var tYear = myDate.getFullYear();
      roomApi.GetRoomForecast(params).then(res => {
        _this.roomData = res.Data;
        for (let i = 0; i < _this.roomData.DataSummary.length; i++) {
          const item = _this.roomData.DataSummary[i];
          var itemDateArray = item.Date.split("-");
          item.Date =
            tYear + "年" + itemDateArray[0] + "月" + itemDateArray[1] + "日";
          let obj = {};
          item.PredictRoomInfos.forEach(el => {
            if (!obj[el.PredictRoomInfoTypes]) {
              obj[el.PredictRoomInfoTypes] = [el];
            } else {
              obj[el.PredictRoomInfoTypes].push(el);
            }
          });
          item.PredictRoomInfosObj = obj;
        }
        for (let i = 0; i < _this.roomData.Details.length; i++) {
          var itemRoom = _this.roomData.Details[i];
          for (let l = 0; l < itemRoom.PredictCalendars.length; l++) {
            var itemDay = itemRoom.PredictCalendars[l];
            let obj = {};
            itemDay.PredictRoomInfos.forEach(item => {
              if (!obj[item.PredictRoomInfoTypes]) {
                obj[item.PredictRoomInfoTypes] = [item];
              } else {
                obj[item.PredictRoomInfoTypes].push(item);
              }
            });
            itemDay.PredictRoomInfosObj = obj;
          }
        }
      });
    },
    onSearch() {
      const params = {
        CompanyId: this.user.CompanyId,
        StartDate: this.daterange[0],
        EndDate: this.daterange[1],
      };
      this.getData(params);
    },
  },
};
</script>
<style lang="less" scoped>
@import "./RoomForecast.less";
</style>
